import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { UserSettings } from '../../enums/user-settings/user-settings';
import { useUserSetting } from '../../hooks/use-user-setting';
import { saveUserSetting } from '../../store/user/user.actions';

export const useNoticeLastDismissedDate = () => {
  const dispatch = useDispatch();

  const noticeLastDismissedDate = useUserSetting(UserSettings.nonDefaultTermsNoticeLastDismissedDate.settingName);
  const dismissNotice = useCallback(
    (dismissDate) => {
      dispatch(
        saveUserSetting({
          settingName: UserSettings.nonDefaultTermsNoticeLastDismissedDate.settingName,
          settingValue: dismissDate,
          excludeV3prefix: true,
        }),
      );
    },
    [dispatch],
  );

  return {
    noticeLastDismissedDate,
    dismissNotice,
  };
};

export const useFedExNoticeLastDismissedDate = () => {
  const dispatch = useDispatch();

  const noticeLastDismissedDate = useUserSetting(UserSettings.fedExNoticeLastDismissedDate.settingName);
  const dismissNotice = useCallback(
    (dismissDate) => {
      dispatch(
        saveUserSetting({
          settingName: UserSettings.fedExNoticeLastDismissedDate.settingName,
          settingValue: dismissDate,
          excludeV3prefix: true,
        }),
      );
    },
    [dispatch],
  );

  return {
    noticeLastDismissedDate,
    dismissNotice,
  };
};
